const headers = {
  name: "Project",
  navigate: {
    path: [
      {
        name: "Project",
        path: "/app/projects",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
